<div class="kt-splash-screen" style="margin-top: -70px;">
    <img src="./assets/media/logos/logo.png" class="logo" alt=""/>
    <span class="message">Loading...</span>
  </div>